import { __assign, __rest } from "tslib";
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Ellipsis, { extractEllipsisProps } from '../common/Ellipsis';
import { st, classes } from './Heading.st.css';
import { EllipsisCommonProps } from '../common/PropTypes/EllipsisCommon';
import deprecationLog from '../utils/deprecationLog';
import { WixStyleReactMaskingContext } from '../WixStyleReactMaskingProvider/context';
export var APPEARANCES = {
    H1: 'H1',
    H2: 'H2',
    H3: 'H3',
    H4: 'H4',
    H5: 'H5',
    H6: 'H6',
};
export var SIZES = {
    extraLarge: 'H1',
    large: 'H2',
    medium: 'H3',
    small: 'H4',
    tiny: 'H5',
    extraTiny: 'H6',
};
var Heading = function (props) {
    var _a = extractEllipsisProps(props), ellipsisProps = _a.ellipsisProps, componentProps = _a.componentProps;
    var light = componentProps.light, appearance = componentProps.appearance, as = componentProps.as, children = componentProps.children, dataHook = componentProps.dataHook, size = componentProps.size, id = componentProps.id, headingProps = __rest(componentProps, ["light", "appearance", "as", "children", "dataHook", "size", "id"]);
    useEffect(function () {
        if (appearance) {
            deprecationLog('<Heading/> - prop "appearance" is deprecated and will be removed in next major release, please use "size" property instead.');
        }
    }, [appearance]);
    var headingType = SIZES[size] || appearance;
    return (React.createElement(WixStyleReactMaskingContext.Consumer, null, function (_a) {
        var maskingClassNames = _a.maskingClassNames;
        return (React.createElement(Ellipsis, __assign({}, ellipsisProps, { wrapperClassName: st(classes.root, {
                appearance: headingType,
            }), render: function (_a) {
                var ref = _a.ref, ellipsisClasses = _a.ellipsisClasses;
                return React.createElement(as || headingType.toLowerCase(), __assign(__assign({}, headingProps), { id: id, ref: ref, 'data-hook': dataHook, className: st(classes.root, { light: light, appearance: headingType }, ellipsisClasses(props.className), maskingClassNames), 'data-appearance': appearance, 'data-size': size, 'data-light': light, 'data-mask': !!maskingClassNames }), children);
            } })));
    }));
};
Heading.displayName = 'Heading';
Heading.propTypes = __assign(__assign({}, EllipsisCommonProps), { 
    /** Applies a data-hook HTML attribute that can be used in the tests. */
    dataHook: PropTypes.string, 
    /** Renders any kind of content within a heading. Usually it’s a text string. */
    children: PropTypes.any, 
    /** Invert heading style so it can be used on a dark or image background. */
    light: PropTypes.bool, 
    /** this prop is deprecated and should not be used
     * @deprecated
     */
    appearance: PropTypes.oneOf(Object.keys(APPEARANCES)), 
    /** Renders the heading as any other given HTML tag */
    as: PropTypes.string, 
    /** Controls the heading's visual size and HTML tag appearance. HTML tag can be overridden with ‘as’ prop. */
    size: PropTypes.oneOf(Object.keys(SIZES)), 
    /** Identifies the element that labels or describes the text element */
    id: PropTypes.string });
Heading.defaultProps = __assign({ appearance: APPEARANCES.H1, light: false }, Ellipsis.defaultProps);
export default Heading;
//# sourceMappingURL=Heading.js.map